import { URLS } from '@/pages/urls'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { ProjectedEarnings } from './ProjectedEarnings'
import { StakeAmountInput } from './StakeAmountInput'
import { StakeButton } from './StakeButton'

type StakeFormProps = {
  balance: number
  onSuccess: () => void
}

export const StakeForm = ({ balance, onSuccess }: StakeFormProps) => {
  const [stakeAmount, setStakeAmount] = useState('')

  return (
    <div className="flex flex-col gap-6 max-md:gap-4">
      <StakeAmountInput value={stakeAmount} onChange={setStakeAmount} balance={balance} />
      <ProjectedEarnings stakeAmount={stakeAmount} />
      <div className="flex flex-col gap-4">
        <StakeButton stakeAmount={stakeAmount} onSuccess={onSuccess} setStakeAmount={setStakeAmount} />
        <p className="text-gray-90 text-xs">
          By clicking &quot;Stake SOL&quot; you agree to the DataHive AI{' '}
          <Link to={URLS.TERMS_CONDITIONS} target="_blank" className="hover:text-orange underline">
            Terms of Service
          </Link>{' '}
          and acknowledge that your data will be handled in accordance with our{' '}
          <Link to={URLS.PRIVACY_POLICY} target="_blank" className="hover:text-orange underline">
            Privacy Policy
          </Link>
          .
        </p>
      </div>
    </div>
  )
}
